import type { FC } from 'react'
import { useMemo } from 'react'

import { cleanPhoneNumber } from '@/helpers/phoneHelper'

type PhoneLinkProps = {
  phone: string
  onClick?: (phone: string) => void
}

export const PhoneLink: FC<PhoneLinkProps> = ({ phone, onClick }) => {
  const cleanPhone = useMemo(() => cleanPhoneNumber(phone), [phone])

  const handleClick = () => {
    if (onClick) onClick(cleanPhone)
  }

  return (
    <a href={`tel:${cleanPhone}`} onClick={handleClick} className="phone-link underline">
      {phone}
    </a>
  )
}
